import styled from '@emotion/styled'

import { border, colors, vars, zIndex } from '@/styles/theme'
import { mediaDown, mediaUp } from '@/styles/media'
import { Text2 } from '@/styles/typography'
import { focusVisible } from '@/styles/mixins'

export const Container = styled.header<{
  scrolled: boolean
  isMobile?: boolean
  isDark?: boolean
  backgroundColor?: string | boolean
}>`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  box-shadow: ${props => (props.scrolled ? border.shadowMenu : '0 0 0 0 #fff')};
  background-color: ${props =>
    props.isMobile
      ? props.backgroundColor
        ? props.backgroundColor
        : props.isDark
        ? `${colors.twilightBlue}`
        : props.scrolled
        ? 'var(--tint)'
        : 'transparent'
      : '#ffffff'};
  z-index: ${zIndex.header};
  html[lang^='ar'] & {
    direction: ltr;
  }
`
export const NavigationContainer = styled.nav<{ scrolled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${props => (props.scrolled ? '46px' : vars.headerHeightMobile)};
  margin: 0px 20px;

  ${mediaUp('lg')} {
    height: ${props => (props.scrolled ? '98px' : vars.headerHeight)};
    width: 1280px;
    margin: 0 auto;
    justify-content: space-between;
  }
`

export const LinksListWrapper = styled.nav<{ open: boolean }>`
  position: fixed;
  display: flex;
  opacity: 0;
  pointer-events: none;

  ${props =>
    props.open &&
    `
    opacity: 1;
    pointer-events: all;
  `}

  ${mediaDown('lg')} {
    background-color: var(--accentFirst);
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
    z-index: ${Number(zIndex.header) - 1};
  }

  ${mediaUp('lg')} {
    position: relative;
    opacity: 1;
    pointer-events: all;
  }
`

export const LogoWrapper = styled.div<{
  narrow?: boolean
}>`
  ${focusVisible};
  position: relative;
  z-index: ${zIndex.burger};
  width: ${props => (props.narrow ? '28px' : '113px')};
  height: 28px;
  cursor: pointer;

  ${mediaUp('lg')} {
    height: 40px;
    width: ${props => (props.narrow ? '45px' : '140.69px')};
  }

  img {
    height: 100%;
    object-fit: contain;
  }
`

export const BurgerWrapper = styled.div<{
  backgroundColor: string
  scrolled?: boolean
}>`
  display: flex;
  cursor: pointer;
  z-index: ${zIndex.burger};
  background-color: ${props =>
    props.scrolled ? 'transparent' : 'transparent'};
  height: auto;
  align-items: center;
  padding-right: 20px;
  position: absolute;
  right: 0;
  contain: layout;
  width: 44px;
  height: 44px;

  ${mediaUp('lg')} {
    display: none;
  }
`

export const Breadcrumb = styled(Text2)`
  margin-inline-end: auto;
  margin-inline-start: 20px;

  ${mediaDown('lg')} {
    display: none;
  }
`

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${zIndex.header + 2};
`
export const OpenedNavbar = styled.div<{
  isMobile: boolean
  backgroundColor: string
  scrolled?: boolean
}>`
  display: flex;
  justify-content: space-between;
  padding: ${props => (props.isMobile ? '8px 16px' : '0px')};
  height: auto;
  align-items: center;
  background-color: ${props =>
    props.isMobile
      ? props.scrolled
        ? 'transparent'
        : 'transparent'
      : 'transparent'};
  position: relative;
  z-index: 91;
`

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;

  img:nth-of-type(2) {
    width: 60%;
    margin-top: 4px;
  }
`
